<div id="agreements"></div>

<!--- Slide-out Betslip -->
@if (device.isMobile && !isMyBetsInCasino) {
    <lazy-component
        data-crlat="betslipSidebar"
        moduleUri="@lazy-modules-module/sidebar/sidebar.module#SideBarModule"
        [inputs]="{ sideClass: 'slide-out-betslip', sideHideClose: true, sidePosition: 'bottom', sideId: 'slide-out-betslip' }"
        entryComponent="SidebarComponent">
    </lazy-component>
}

<!-- Gaming Overlay -->
@if (isGamingOpen && !isMyBetsInCasino) {
    <lazy-component moduleUri="@lazy-modules/gamingOverlay/gaming-overlay.module#GamingOverlayModule"> </lazy-component>
}

<!-- Quiz dialog component -->
@if (!isMyBetsInCasino) {
    <lazy-component moduleUri="@lazy-modules-module/quiz/quiz-dialog.module#QuizDialogModule" [inputs]="{ user: user }"> </lazy-component>
}

<!-- lazy-initializer-homepage component -->
@if (!isMyBetsInCasino) {
    <lazy-component
        moduleUri="@lazy-modules-module/lazy-initializer-homepage/lazy-initializer-homepage.module#LazyInitializerHomepageModule"></lazy-component>
}

<!-- TimeLine component -->
@if (user?.data?.custId && sysConfig?.FeatureToggle?.Timeline && device.isMobile && !isMyBetsInCasino) {
    <lazy-component moduleUri="@lazy-modules-module/timeline/timeline.module#TimelineModule" [inputs]="{ user: user }"> </lazy-component>
}

<div class="side-page" [ngClass]="{ skeleton: !device.isDesktop && sysConfig?.FeatureToggle.skeletonLoadingScreen }" scroll-fix>
    <!--- Content -->
    <div id="page-content" data-crlat="pageContent">
        <!--- Menu Carousel-->
        <div [ngClass]="{ 'carousel-block': isHomeURL }">
            @if (menuItems && isHomeURL) {
                <ld-flag1></ld-flag1>
                <ld-flag2 *ngIf="user.status"></ld-flag2>
                <lazy-component
                    data-crlat="menuCarousel"
                    moduleUri="@lazy-modules-module/carouselMenu/carousel-menu.module#CarouselMenuModule"
                    [inputs]="{
                        menuItems: menuItems,
                        isSticky: true,
                        isTopScroll: true,
                        GATrackingModule: 'sportsribbon',
                        GTMTrackingObj: GTMTrackingObj,
                        carouselClass: 'sticky-carousel sports-ribbon',
                    }"
                    entryComponent="CarouselMenuComponent">
                </lazy-component>
            }
        </div>
        <div id="page-wrap-content">
            <!--- Left Side -->
            <left-column></left-column>

            <div class="page-wrapper">
                <div class="page-wrap-inner">
                    <div data-uat="pageContent" id="content">
                        <router-outlet></router-outlet>
                        @defer (on viewport) {
                            <lazy-component moduleUri="@lazy-modules/seoStaticBlock/seo-static-block.module#SeoStaticBlockModule"> </lazy-component>
                        } @placeholder {
                            <div></div>
                        }
                    </div>

                    <!--- Right Side -->
                    @if (showRC) {
                        <lazy-component
                            moduleUri="@rightColumnModule/right-column.module#RightColumnModule"
                            id="right-column"
                            data-crlat="rightColumn">
                        </lazy-component>
                    }

                    @if (betSlipAnimation === 'On') {
                        <button class="btn-bet bet-animation animate" data-crlat="betSlipAnimation"></button>
                    }
                </div>
            </div>
        </div>
    </div>

    <!--- Footer -->
    @if (!device.isRobot()) {
        <div class="network-indicator-parent">
            <lazy-component
                moduleUri="@lazy-modules/networkIndicator/network-indicator.module#NetworkIndicatorModule"
                [inputs]="{ config: NW_I_Object }">
            </lazy-component>
        </div>
    }
    <footer-section data-crlat="footer"></footer-section>
</div>

<!-- SVG ICONS -->
@if (initialIcons) {
    <svg-list id="iconsSprite_cmsInitial" [list]="initialIcons" [keepFill]="true"></svg-list>
}
@if (featuredIcons) {
    <svg-list id="iconsSprite_cmsFeatured" [list]="featuredIcons" [keepFill]="true"></svg-list>
}
@if (additionalIcons) {
    <svg-list id="iconsSprite_cmsAdditional" [list]="additionalIcons" [keepFill]="true"></svg-list>
}

<live-serv-iframe><!-- LiveServ integration iframe --></live-serv-iframe>

@if (!isMyBetsInCasino && !streamBetVideoMode) {
    <loading-overlay data-crlat="loadingOverlay"></loading-overlay>
}

<oxygen-dialog></oxygen-dialog>
<oxygen-notification></oxygen-notification>

@if (!isMyBetsInCasino) {
    <quickbet-panel-wrapper></quickbet-panel-wrapper>
}

@if (!isMyBetsInCasino) {
    <promotion-footer></promotion-footer>
}

@if (sysConfig?.Connect?.overlay && !isMyBetsInCasino) {
    <lazy-component moduleUri="@retail-lazy-load/retail.module#RetailModule" entryComponent="RetailOverlayComponent"> </lazy-component>
}
